
export class ProcedureInstanceDocBase {

	id!: number;
	sizeBytes!: number;
	fileFormat!: string;
	generated!: boolean;
	procedureInstanceId!: number;
	creationDate!: Date;
	type!: number;
	name!: string;
	documentLabel!: string;
	desalArchiveRefId!: string;
	desalReceptorDocumentRefId!: string;
	desalPromoterDocumentRefId!: string;
	desalReceptorFileRefId!: string;
	desalPromoterFileRefId!: string;
	desalDocumentType!: string;
	receptorIne10!: string;
	promoterIne10!: string;

	static from(source: ProcedureInstanceDoc): ProcedureInstanceDocBase {
		let current = new ProcedureInstanceDocBase();
		Object.assign(current, source)
		current.creationDate = new Date(source.creationDate)

		return current;
	}
}

export interface ProcedureInstanceDoc extends ProcedureInstanceDocBase {

}